import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import type { FuelPlatformOverview } from "@/lib/fuel-analytics";
import { MetricCard } from "@/components/ui/Card";
import { formatCurrency, formatFuelPrice, formatNumber } from "@/lib/utils";

type Props = {
  monthLabel: string;
  overview: FuelPlatformOverview;
  spendLink: string;
};

export function FuelCurrentMonthMetrics({ monthLabel, overview, spendLink }: Props) {
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-[11px] font-bold uppercase tracking-wider text-muted">{monthLabel}</p>
          <p className="mt-0.5 text-sm text-muted">Current month fuel activity</p>
        </div>
        <Link
          to={spendLink}
          className="inline-flex items-center gap-1 rounded-full bg-canvas px-4 py-2 text-sm font-semibold transition hover:bg-canvas-hover"
        >
          View spend breakdown
          <ChevronRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="stagger-children grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        <MetricCard label="Total spend" value={formatCurrency(overview.totalSpent)} />
        <MetricCard label="Fill-ups" value={formatNumber(overview.totalFillUps)} />
        <MetricCard label="Litres" value={`${formatNumber(Math.round(overview.totalLitres))} L`} />
        <MetricCard
          label="Active users"
          value={formatNumber(overview.activeUsers)}
          detail={`Avg ${formatFuelPrice(overview.avgPricePerLitre)}/L · ${formatCurrency(overview.avgFillCost)}/fill`}
        />
      </div>
    </div>
  );
}
